module.exports = __webpack_public_path__ + "static/media/UNI-logo.806dece0.png";